<!--
 * @Author: Latte
 * @Date: 2021-08-05 15:00:07
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-18 15:58:46
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\teamMgt\index.vue
-->

<template>
  <div class="app-container">
    <el-tabs v-model="activeIndex" type="border-card" @tab-click="handleClick" v-tab-change:activeIndex="setActiveName">
      <!-- 团队管理 -->
      <el-tab-pane label="团队管理" name="0" v-loading="loading">
        <my-table :tableData="tableData" :conf="conf" :pageOpt="pageOpt">
          <!-- 状态 -->
          <template v-slot:status="slotData">
            <el-tag :type="slotData.data.auditStatus | tagFilter">{{
              slotData.data.auditStatus | statusFilter
            }}</el-tag>
          </template>

          <!-- 操作 -->
          <template v-slot:operation="slotData">
            <el-button
              type="primary"
              size="small"
              @click.stop="goDetail(slotData.data)"
              :disabled="slotData.data.auditStatus === 1 ? false : true"
              >查看详情</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click.stop="openUpdateDialog(slotData.data)"
              :disabled="slotData.data.auditStatus === 1 ? false : true"
              >修改信息</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click.stop="goMember(slotData.data)"
              :disabled="slotData.data.auditStatus === 1 ? false : true"
              >成员管理</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click.stop="goRequest(slotData.data)"
              :disabled="slotData.data.auditStatus === 1 ? false : true"
            >
              入团管理
            </el-button>
            <el-button
              type="success"
              size="small"
              @click.stop="allow(slotData.data)"
              :disabled="slotData.data.auditStatus === 0 ? false : true"
              >通过申请</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click.stop="openRefuseDialog(slotData.data)"
              :disabled="slotData.data.auditStatus === 0 ? false : true"
              >拒绝申请</el-button
            >
          </template>
        </my-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 修改信息对话框 -->
    <el-dialog title="修改内容" width="50%" :visible.sync="updateDialog">
      <el-form :model="updateForm">
        <el-form-item label="团队ID：">
          <el-input v-model="updateForm.teamID" disabled></el-input>
        </el-form-item>
        <el-form-item label="团队名称：">
          <el-input
            v-model="updateForm.teamName"
            placeholder="请输入团队名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="团队介绍：">
          <el-input
            v-model="updateForm.teamIntro"
            placeholder="请输入团队介绍"
          ></el-input>
        </el-form-item>
        <el-form-item label="团队所属省份：">
          <el-input
            v-model="updateForm.province"
            placeholder="请输入团队所属省份"
          ></el-input>
        </el-form-item>
        <el-form-item label="团队所属城市：">
          <el-input
            v-model="updateForm.city"
            placeholder="请输入团队所属城市"
          ></el-input>
        </el-form-item>
        <el-form-item label="团队所属区/县：">
          <el-input
            v-model="updateForm.district"
            placeholder="请输入团队所属区/县"
          ></el-input>
        </el-form-item>
        <el-form-item label="访问权限">
          <el-select
            v-model="updateForm.accessAuthority"
            placeholde="请选择状态"
          >
            <el-option
              v-for="item in options"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" @click="updateDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="update()"
          >提 交</el-button
        >
      </div>
    </el-dialog>

    <!-- 拒绝申请对话框 -->
    <el-dialog title="拒绝原因" width="40%" :visible.sync="refuseDialog">
      <el-input
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="请输入内容"
        v-model="refuseReason"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="refuseDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="refuse()"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  addDiagnosticTeam,
  allowTeamApplication,
  getTeamDetail,
  getAllTeamList,
  updateTeamDetail,
  refuseTeamApplication,
} from "@/api/system/diagnosisManagement/diagnosticTeamManagement";
import { handleRes } from "@/utils/handleRes";
import myTable from "@/components/MyTable/index";
import { diagnosticTeamConf } from "@/config/tableConfig/systemMgt/diagnosticMgt/diagnosticTeam";

export default {
  components: {
    myTable,
  },

  provide() {
    this.pageOpt = Vue.observable(this.pageOpt);

    return {
      pageOpt: this.pageOpt,
    };
  },

  data() {
    return {
      activeIndex: "0", //当前索引
      loading: false, // 加载开关
      conf: diagnosticTeamConf, //表格栏配置
      allTeamList: [], // 团队详情列表
      tableData: [], // 传值给子组件mytable
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      memberDialog: false, // 成员管理对话框
      memberList: [], // 成员管理详情
      refuseDialog: false, // 拒绝团队申请对话框
      refuseReason: "", // 拒绝团队申请原因
      refuseForm: {}, // 被拒团队详情
      updateDialog: false, //更新团队信息对话框
      updateForm: {}, //更新团队信息详情
      teamForm: {}, // 团队具体信息
      options: [
        { label: "需要申请", value: 0 },
        { label: "公开不需申请", value: 1 },
        { label: "私有不能申请", value: 2 },
      ],
      memberOpt: Object.freeze([
        { label: "提交的会诊申请数", prop: "consultationReqCount" },
        { label: "成员 ID", prop: "teamUserID" },
        { label: "成员姓名", prop: "firstName" },
        { label: "成员手机号", prop: "mobilePhone" },
        {
          label: "成员加入时间",
          prop: "joinTime",
          hasFilter: true,
          filter: function (val) {
            return new Date(val).toLocaleString();
          },
        },
        {
          label: "成员角色",
          prop: "role",
          hasFilter: true,
          filter: function (val) {
            switch (val) {
              case 0:
                return "普通用户";
              case 1:
                return "管理员";
              case 2:
                return "团长，创建者";
            }
          },
        },
        {
          label: "当前成员在会诊系统的角色",
          prop: "consultationUserRole",
          hasFilter: true,
          filter: function (val) {
            switch (val) {
              case -1:
                return "普通角色";
              case 0:
                return "医生";
              case 1:
                return "会诊专家";
              case 2:
                return "医生&会诊专家";
            }
          },
        },
        {
          label: "权限",
          prop: "permission",
          hasFilter: true,
          filter: function (val) {
            switch (val) {
              case 0:
                return "允许会诊申请但不允许会诊诊断";
              case 1:
                return "允许会诊申请和会诊诊断";
            }
          },
        },
        { label: "完成的报告数", prop: "reportCount" },
        { label: "提交的会诊数", prop: "consultationCount" },
      ]),
    };
  },

  filters: {
    tagFilter(val) {
      if (val === undefined) return;
      if (val === 0) {
        return "";
      } else if (val === 1) {
        return "success";
      } else if (val === 2) {
        return "danger";
      }
    },

    statusFilter(val) {
      if (val === undefined) return;
      if (val === 0) {
        return "待审核";
      } else if (val === 1) {
        return "已通过";
      } else if (val === 2) {
        return "已拒绝";
      }
    },
  },

  methods: {
    /**
     * @description: 跳转成员管理页面
     * @param {*} scope
     * @return {*}
     */
    goMember(scope) {
      console.log(" ----------------------");
      console.log("goMember , scope", scope);
      console.log(" ----------------------");
      this.$router.push({
        name: "diagnosticTeamMember",
        params: {
          teamID: scope.teamID,
        },
      });
    },

    /**
     * @description: 跳转入团管理页面
     * @param {*} scope
     * @return {*}
     */
    goRequest(scope) {
      console.log(" ----------------------");
      console.log("goRequest , scope", scope);
      console.log(" ----------------------");
      this.$router.push({
        name: "diagnosticJoinTeamReq",
        params: {
          teamID: scope.teamID,
        },
      });
    },

    /**
     * @description: 查看团队详情
     * @param {*} scope
     * @return {*}
     */
    goDetail(scope) {
      console.log(" ----------------------");
      console.log("goDetail , scope", scope);
      console.log(" ----------------------");
      this.$router.push({
        name: "diagnosticTeamDetail",
        params: {
          teamDetail: scope,
        },
      });
    },

    /**
     * @description: 通过团队创建申请
     * @param {*} scope
     * @return {*}
     */
    allow(scope) {
      this.loading = true;
      console.log(scope);
      const data = {
        auditStatus: 1,
        reason: "",
        teamID: scope.teamID,
      };

      allowTeamApplication(data).then((res) => {
        console.log(" ------------------------------");
        console.log("allowTeamApplication , res", res);
        console.log(" ------------------------------");

        handleRes(res);
        this.getAllTeamList();
        this.utils.stopLoading(this);
      });
      this.utils.stopLoading(this);
    },

    /**
     * @description: 打开拒绝申请对话框
     * @param {*} scope
     * @return {*}
     */
    openRefuseDialog(scope) {
      this.refuseDialog = true;
      this.refuseForm = scope;
    },

    /**
     * @description: 拒绝团队申请
     * @param {*}
     * @return {*}
     */
    refuse() {
      console.log(this.refuseForm);
      this.loading = true;
      const refuseReason = this.refuseReason;
      if (refuseReason === "") {
        this.$message({
          message: "拒绝原因不能为空!",
          type: "error",
          center: true,
          showClose: true,
        });
        this.utils.stopLoading(this);
      } else {
        this.loading = true;
        const data = {
          auditStatus: 2,
          teamID: this.refuseForm.teamID,
          reason: refuseReason,
        };

        refuseTeamApplication(data).then((res) => {
          console.log("res", res);
          handleRes(res);
          this.getAllTeamList();
          this.refuseDialog = false;
          this.utils.stopLoading(this);
        });
      }

      this.utils.stopLoading(this);
    },

    /**
     * @description: 打开更新团队信息对话框
     * @param {*} data
     * @return {*}
     */
    openUpdateDialog(data) {
      console.log("data", data);
      this.updateForm.teamID = data.teamID;
      this.updateForm = data;
      this.updateDialog = true;
    },

    /**
     * @description: 更新团队信息
     * @param {*}
     * @return {*}
     */
    update() {
      this.loading = true;
      this.updateDialog = true;
      const data = {
        accessAuthority: this.updateForm.accessAuthority,
        city: this.updateForm.city,
        district: this.updateForm.district,
        province: this.updateForm.province,
        teamID: this.updateForm.teamID,
        teamIntro: this.updateForm.teamIntro,
        teamName: this.updateForm.teamName,
      };

      updateTeamDetail(data).then((res) => {
        console.log(" --------------------------");
        console.log("updateTeamDetail , res", res);
        console.log(" --------------------------");
        handleRes(res);
        this.updateDialog = false;
        this.getAllTeamList();
        this.utils.stopLoading(this);
      });
    },

    handleClick() {
      // this.currentPage = 1
      // this.searchValue = ''
      // this.refreshCurrentList()
    },

    /**
     * @description: 获取所有团队列表
     * @param {*}
     * @return {*}
     */
    getAllTeamList() {
      this.loading = true;
      const params = {
        keyword: "",
        pageIndex: this.pageOpt.currentPage,
        pageSize: this.pageOpt.pageSize,
        sortName: "",
        sortOrder: "",
        where: "",
      };

      getAllTeamList(params).then((res) => {
        this.allTeamList = res.data.list;
        this.pageOpt.totalCount = res.data.total;
        console.log(" --------------------------------------------------");
        console.log("getAllTeamList , this.allTeamList", this.allTeamList);
        console.log(" --------------------------------------------------");

        this.initTeamList();
        this.tableData = this.allTeamList;

        this.utils.stopLoading(this);
      });
    },

    initTeamList() {
      this.allTeamList.forEach((element) => {
        element.fullName = element.firstName + element.lastName;

        element.fullPlace = element.province + element.city + element.district;

        switch (element.accessAuthority) {
          case 0:
            element.stringAccessAuthority = "需要申请";
            break;
          case 1:
            element.stringAccessAuthority = "公开不需申请";
            break;
          case 2:
            element.stringAccessAuthority = "私有不能申请";
        }
      });
    },
  },

  created() {
    this.getAllTeamList();
  },

  watch: {
    "pageOpt.currentPage": {
      deep: true,
      handler(newData, oldData) {
        console.log(" -----------------------------------");
        console.log("handler , this.pageOpt", this.pageOpt);
        console.log("handler , newData", newData);
        console.log("handler , oldData", oldData);
        console.log(" -----------------------------------");
        this.getAllTeamList();
      },
    },
  },
};
</script>

<style lang='scss' scoped>
.operation {
  display: inline-block;
  margin-right: 10px;
}
.el-button {
  width: 80px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
</style>